export type StudioStatusColor = 'default' | 'success' | 'error' | 'warning' | 'info';

const STATUS_LABELS: Record<string, string> = {
  draft: 'Utkast',
  generating: 'Genererar',
  pending: 'Väntar',
  processing: 'Bearbetar',
  completed: 'Klar',
  approved: 'Godkänd',
  rejected: 'Avslagen',
  published_to_dam: 'Publicerad',
  failed: 'Misslyckad',
};

const STATUS_COLORS: Record<string, StudioStatusColor> = {
  draft: 'default',
  generating: 'info',
  pending: 'warning',
  processing: 'info',
  completed: 'default',
  approved: 'success',
  rejected: 'error',
  published_to_dam: 'success',
  failed: 'error',
};

export function getAiImageStatusLabel(status?: string): string {
  if (!status) return 'Okänd';
  return STATUS_LABELS[status] || status;
}

export function getAiImageStatusColor(status?: string): StudioStatusColor {
  if (!status) return 'default';
  return STATUS_COLORS[status] || 'default';
}

export interface GenerationReadinessInput {
  view: 'create' | 'recipe' | 'wine' | 'edit';
  prompt: string;
  hasRecipe?: boolean;
  hasImageA?: boolean;
  hasImageB?: boolean;
  hasEditSource?: boolean;
  hasMask?: boolean;
  hasModel?: boolean;
}

export function getGenerationBlockedReason(input: GenerationReadinessInput): string | undefined {
  if (input.view === 'wine') {
    if (!input.hasImageA && !input.hasImageB) return 'Ladda upp Bild A och Bild B.';
    if (!input.hasImageA) return 'Ladda upp Bild A.';
    if (!input.hasImageB) return 'Ladda upp Bild B.';
  }

  if (input.view === 'recipe' && !input.hasRecipe) {
    return 'Välj en receptbild.';
  }

  if (input.view === 'edit') {
    if (!input.hasEditSource) return 'Välj en basbild.';
    if (!input.hasModel) return 'Välj en redigeringsmodell.';
    if (!input.hasMask) return 'Måla området som AI får ändra.';
  }

  if (!input.prompt.trim()) {
    return input.view === 'edit' ? 'Skriv en instruktion.' : 'Skriv en prompt först.';
  }

  return undefined;
}
